interface Service {
  label: string;
}

interface AIAnswerBlockProps {
  question: string;
  answer: string;
  services?: Service[];
}

const defaultServices: Service[] = [
  { label: 'Asbestos Abatement' },
  { label: 'Mold Remediation' },
  { label: 'Hazardous Material Removal' },
  { label: 'Disaster Restoration' },
  { label: 'Environmental Consulting' },
  { label: 'Lead-Based Paint Removal' },
];

export default function AIAnswerBlock({ question, answer, services }: AIAnswerBlockProps) {
  const displayServices = services ?? defaultServices;

  return (
    <section className="bg-ecos-slate py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">

          {/* Left label column */}
          <div className="lg:col-span-3">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-ecos-green rounded-sm flex-shrink-0">
                <i className="ri-sparkling-line text-white text-sm"></i>
              </div>
              <span className="text-ecos-green text-xs uppercase tracking-widest font-semibold">AI Overview</span>
            </div>
            <p className="text-ecos-text-light text-xs leading-relaxed">
              Structured for AI search engines, voice search, and answer extraction.
            </p>

            {displayServices.length > 0 && (
              <div className="mt-8 space-y-2">
                {displayServices.map((s) => (
                  <div key={s.label} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-ecos-green rounded-full flex-shrink-0"></div>
                    <span className="text-ecos-text text-xs">{s.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Answer content */}
          <div className="lg:col-span-9">
            <div className="border-l-2 border-ecos-green pl-8">
              <h2 className="font-serif text-ecos-charcoal text-3xl lg:text-4xl font-semibold mb-6 leading-tight">
                {question}
              </h2>
              <p className="text-ecos-text text-base lg:text-lg leading-[1.9] max-w-3xl">
                {answer}
              </p>
              <div className="flex flex-wrap items-center gap-6 mt-8 pt-8 border-t border-ecos-border">
                {[
                  { icon: 'ri-verified-badge-line', text: 'EPA/OSHA Compliant' },
                  { icon: 'ri-shield-check-line', text: 'Fully Licensed & Insured' },
                  { icon: 'ri-map-pin-line', text: 'Colorado Certified' },
                ].map((item) => (
                  <div key={item.text} className="flex items-center gap-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${item.icon} text-ecos-green text-base`}></i>
                    </div>
                    <span className="text-ecos-text text-sm font-medium">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
